import { render, staticRenderFns } from "./BibliometricModal.vue?vue&type=template&id=7491feaa&scoped=true"
import script from "./BibliometricModal.vue?vue&type=script&lang=js"
export * from "./BibliometricModal.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BibliometricModal.vue?vue&type=style&index=1&id=7491feaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7491feaa",
  null
  
)

export default component.exports